import React from 'react'
import { Image } from 'primereact/image';

import { alergenosEnum } from '../interface/alergenos'
import altramuz from '../resources/icons/redondo/altramuz.png';
import apio from '../resources/icons/redondo/apio.png';
import cacahuetes from '../resources/icons/redondo/cacahuetes.png';
import crustaceos from '../resources/icons/redondo/crustaceos.png';
import frutos_secos from '../resources/icons/redondo/frutos-secos.png';
import gluten from '../resources/icons/redondo/gluten.png';
import huevos from '../resources/icons/redondo/huevos.png';
import lacteos from '../resources/icons/redondo/lacteos.png';
import moluscos from '../resources/icons/redondo/moluscos.png';
import mostaza from '../resources/icons/redondo/mostaza.png';
import pescado from '../resources/icons/redondo/pescado.png';
import sesamo from '../resources/icons/redondo/sesamo.png';
import soja from '../resources/icons/redondo/soja.png';
import sulfitos from '../resources/icons/redondo/sulfitos.png';



interface IProps {
    nameIcon: alergenosEnum,
    width: string
}
export const AlergenoIcon = ({nameIcon, width}: IProps) => {

    return (
        <div className="p-component w-max">
            {
                nameIcon === alergenosEnum.altramuz &&  <Image alt={nameIcon} src={altramuz} width={width} />
            }
            {
                nameIcon === alergenosEnum.apio &&  <Image alt={nameIcon} src={apio} width={width} />
            }
            {
                nameIcon === alergenosEnum.cacahuetes &&  <Image alt={nameIcon} src={cacahuetes} width={width} />
            }
            {
                nameIcon === alergenosEnum.crustaceos &&  <Image alt={nameIcon} src={crustaceos} width={width} />
            }
            {
                nameIcon === alergenosEnum.frutos_secos &&  <Image alt={nameIcon} src={frutos_secos} width={width} />
            }
            {
                nameIcon === alergenosEnum.gluten &&  <Image alt={nameIcon} src={gluten} width={width} />
            }
            {
                nameIcon === alergenosEnum.huevos &&  <Image alt={nameIcon} src={huevos} width={width} />
            }
            {
                nameIcon === alergenosEnum.lacteos &&  <Image alt={nameIcon} src={lacteos} width={width} />
            }
            {
                nameIcon === alergenosEnum.moluscos &&  <Image alt={nameIcon} src={moluscos} width={width} />
            }
            {
                nameIcon === alergenosEnum.mostaza &&  <Image alt={nameIcon} src={mostaza} width={width} />
            }
            {
                nameIcon === alergenosEnum.pescado &&  <Image alt={nameIcon} src={pescado} width={width} />
            }
            {
                nameIcon === alergenosEnum.sesamo &&  <Image alt={nameIcon} src={sesamo} width={width} />
            }
            {
                nameIcon === alergenosEnum.soja &&  <Image alt={nameIcon} src={soja} width={width} />
            }
            {
                nameIcon === alergenosEnum.sulfitos &&  <Image alt={nameIcon} src={sulfitos} width={width} />
        }
        </div>
    )
}
